const avatarFormCompany = {
  logo: 'LOGO',
  Typography: 'Aguarde o arquivo subir'
};

export default avatarFormCompany;
